import { z } from 'zod';

// Mirrors the server: the email, or DELETE for Sign in with Apple users whose
// relay address they have never seen.
export const createDeleteAccountSchema = (email: string, message: string) =>
  z.object({
    confirmation: z.string().refine((value) => {
      const typed = value.trim().toLowerCase();
      // Before the profile loads the email is '', which a blank entry would
      // otherwise match.
      const normalizedEmail = email.trim().toLowerCase();
      return (
        typed === 'delete' ||
        (normalizedEmail !== '' && typed === normalizedEmail)
      );
    }, message),
  });

export type DeleteAccountFormValues = z.infer<
  ReturnType<typeof createDeleteAccountSchema>
>;
